import BusinessRouter from './Business.router';
export { default as businessesRoutes } from './routes';

export default BusinessRouter;
